<template>
    <!-- <div> -->
        <el-autocomplete
                size="mini"
                v-model="project"
                :placeholder="$t('project_search')"
                prefix-icon="el-icon-search"
                :fetch-suggestions="querySearchAsync"
                :trigger-on-focus="false"
                @select="handleSelect"
                style="width: 100%; margin-left: 0">
            <template slot-scope="{ item }">
                <div class="value">{{ item.no + ' - ' + item.name }}</div>
            </template>
        </el-autocomplete>
    <!-- </div> -->
</template>

<script>
  import axios from 'axios';
    export default {
      name: 'project-search',
      data() {
        return {
          // debounce: 1,
            links: [],
            project: '',
            timeout:  null
        }
      },
      methods: {
        querySearchAsync(queryString, cb) {
          console.log('queryString', queryString)
          console.log('cb', cb)
          if(queryString.length >= 3) {
            this.loadProjects(queryString).then(data => {
              // let links = data;
              // console.log('this.links', this.links)
              // console.log('links', links)
              // let results = queryString ? links.filter(this.createFilter(queryString)) : links;
              // console.log('results', results)
              // clearTimeout(this.timeout);
              // this.timeout = setTimeout(() => {
                cb(data);
              // }, 5000 * Math.random());
            })
          }else{
            cb([])
          }
        },
        loadProjects(queryString){
          return new Promise((resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(`/api/v1/projects/search?companyId=${this.$route.query.companyId}&text=${queryString}`)
              .then(response => {
                this.links = response.data.projectList
                resolve(response.data.projectList)
              })
              .catch(error => {
                console.log('An error occurred:', error);
                reject(error)
              });
          })
        },
        createFilter(queryString) {
          return (link) => {
            console.log('link.name', link.name)
            console.log('queryString', queryString)
            return (link.no.toLowerCase().indexOf(queryString.toLowerCase()) === 0 || link.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
          };
        },
        handleSelect(item) {
          console.log(item);
          localStorage.setItem('selectedProjectId', this.seletedProject);
          this.$router.push(`/projects?companyId=${this.$route.query.companyId}&projectId=${item.id}`)
          this.$emit('submit', item.id, item.projectRegionId, item.projectStatusId, 'first')
        }
      },
      // mounted() {
      //   this.links = this.loadAll();
      // }
    }
</script>

<style lang="scss" scoped>
/deep/.el-input__prefix {
  left: 0;
}
</style>
